export const TABS = [
  { id: "supplier", label: "Vendors" },
  { id: "brand", label: "Brands" },
  // { id: "stores", label: "Stores" },
  { id: "category", label: "Categories" },
  { id: "item", label: "Items" },
  { id: "unit", label: "Units" },
  { id: "registeredType", label: "Registered Types" },
];

export const INITIAL_FORM_STATE = {
  title: "",
  code: "",
  description: "",
  name: "",
  mobile: "",
  email: "",
  address: "",
  serviceType: "Generic",
  active: true,
  openingDate: "",
  state: "",
  district: "",
  gstRegisteredType: "",
  gstNo: "",
  itemName: "",
  type: "",
  category: "",
  brand: "",
  itemCode: "",
  hsnSacCode: "",
  isUnique: false,
  uniqueName: "",
  isBatchExpiry: false,
  barcode: "",
  units: "",
  itemDescription: "",
  bankIfsc: "",
  bankName: "",
  bankBranch: "",
  bankAccountHolder: "",
  bankAccountNo: "",
  buyer: "",
  store: "",
  vendor: "",
  date: "",
  billNo: "",
  fixingType: "",
  moq: "",
  colour: "",
  profile: "",
  width: "",
  height: "",
  thickness: "",
  quality: "",
};
